const antdConfig = {
  components: {
    Menu: {
      itemSelectedBg: "#EFEEFF",
      itemSelectedColor: "var(--hs-violet)",
      itemColor: "var(--hs-dark-grey-2)",
      itemHoverColor: "var(--hs-dark-grey-2)",
      itemActiveBg: "#EFEEFF",
      itemHoverBg: "#F5F5F5",
      subMenuItemBg: "#fff",
      itemHeight: 36,
    },
  },
};

export default antdConfig;
